import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import {
  ADVERTISE_URL,
  HOME_FAQ,
  upsertHomeFaqJsonLd,
} from "../../../../seo/homeFaq";
import {
  Answer,
  AnswerLink,
  Chevron,
  Question,
  QuestionTitle,
  SectionTitle,
  Summary,
  Wrapper,
} from "./styles";

function HomeFaqSection() {
  useEffect(() => {
    upsertHomeFaqJsonLd(document);
  }, []);

  return (
    <Wrapper>
      <SectionTitle>Perguntas frequentes</SectionTitle>
      {HOME_FAQ.map((item) => (
        <Question key={item.question}>
          <Summary>
            <QuestionTitle>{item.question}</QuestionTitle>
            <Chevron>
              <ChevronDown aria-hidden="true" />
            </Chevron>
          </Summary>
          <Answer>
            {item.parts.map((part, index) => {
              const key = `${item.question}-${index}`;
              if (!part.href) {
                return <React.Fragment key={key}>{part.text}</React.Fragment>;
              }
              if (part.href === ADVERTISE_URL) {
                return (
                  <AnswerLink key={key} href={part.href} target="_blank" rel="noopener noreferrer">
                    {part.text}
                  </AnswerLink>
                );
              }
              return (
                <AnswerLink as={Link} key={key} to={part.href}>
                  {part.text}
                </AnswerLink>
              );
            })}
          </Answer>
        </Question>
      ))}
    </Wrapper>
  );
}

export default HomeFaqSection;
